import React, { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const SelfIdentificationForm = ({ onChildData }) => {
  const [selfIdentification, setSelfIdentification] = useState({
    gender: "",
    pronouns: "",
    veteran: "",
    disability: "",
    ethnicity: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelfIdentification({ ...selfIdentification, [name]: value });
    onChildData({self_identifications:{ ...selfIdentification, [name]: value}});
    setErrors({ ...errors, [name]: false }); // Clear error when user makes a selection
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    // Check for empty fields
    for (const key in selfIdentification) {
      if (selfIdentification[key] === "") {
        newErrors[key] = true; // Set error for empty fields
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Set errors state
      return; // Prevent form submission
    }

    // Format output
    const output = `self_identification:\n  gender: "${selfIdentification.gender}"\n  pronouns: "${selfIdentification.pronouns}"\n  veteran: "${selfIdentification.veteran}"\n  disability: "${selfIdentification.disability}"\n  ethnicity: "${selfIdentification.ethnicity}"`;

    console.log(output);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 0, pb: 2 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Self Identifications</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl fullWidth required size='small' error={errors.gender} sx={{ mb: 2 }}>
            <InputLabel id="gender-label">Gender</InputLabel>
            <Select
              labelId="gender-label"
              name="gender"
              value={selfIdentification.gender}
              onChange={handleChange}
              label="Gender"
            >
              <MenuItem value="">Select Gender</MenuItem>
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Non-binary">Non-binary</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
            {errors.gender && (
              <FormHelperText>This field is required.</FormHelperText>
            )}
          </FormControl>

          <FormControl
            fullWidth
            required
            error={errors.pronouns}
            sx={{ mb: 2 }}
            size='small'
          >
            <InputLabel id="pronouns-label">Pronouns</InputLabel>
            <Select
              labelId="pronouns-label"
              name="pronouns"
              value={selfIdentification.pronouns}
              onChange={handleChange}
              label="Pronouns"
            >
              <MenuItem value="">Select Pronouns</MenuItem>
              <MenuItem value="He/Him">He/Him</MenuItem>
              <MenuItem value="She/Her">She/Her</MenuItem>
              <MenuItem value="They/Them">They/Them</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
            {errors.pronouns && (
              <FormHelperText>This field is required.</FormHelperText>
            )}
          </FormControl>

          <FormControl
            fullWidth
            size='small'
            required
            error={errors.ethnicity}
            sx={{ mb: 2 }}
          >
            <InputLabel id="ethnicity-label">Ethnicity</InputLabel>
            <Select
              labelId="ethnicity-label"
              name="ethnicity"
              value={selfIdentification.ethnicity}
              onChange={handleChange}
              label="Ethnicity"
            >
              <MenuItem value="">Select Ethnicity</MenuItem>
              <MenuItem value="Asian">Asian</MenuItem>
              <MenuItem value="Black">Black</MenuItem>
              <MenuItem value="Hispanic/Latino">Hispanic/Latino</MenuItem>
              <MenuItem value="White">White</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
            {errors.ethnicity && (
              <FormHelperText>This field is required.</FormHelperText>
            )}
          </FormControl>

          <FormControl
            required
            error={errors.veteran}
            sx={{ mb: 2, display: "block" }}
          >
            <Typography variant="body2">Veteran Status</Typography>
            <RadioGroup
              name="veteran"
              value={selfIdentification.veteran}
              onChange={handleChange}
              row
            >
              <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="No" control={<Radio />} label="No" />
            </RadioGroup>
            {errors.veteran && (
              <FormHelperText>This field is required.</FormHelperText>
            )}
          </FormControl>

          <FormControl
            required
            error={errors.disability}
            sx={{ mb: 2, display: "block" }}
          >
            <Typography variant="body2">Disability Status</Typography>
            <RadioGroup
              name="disability"
              value={selfIdentification.disability}
              onChange={handleChange}
              row
            >
              <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="No" control={<Radio />} label="No" />
            </RadioGroup>
            {errors.disability && (
              <FormHelperText>This field is required.</FormHelperText>
            )}
          </FormControl>

          <Button type="submit" variant="contained" sx={{display:'none'}}>
            Submit
          </Button>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SelfIdentificationForm;
